import { createTheme } from "@mui/material/styles";
import merge from "lodash.merge";
import { theme as passeportTheme } from "./passeportTheme";
import { theme as proTheme } from "./proTheme";

export const theme = merge({}, passeportTheme, proTheme, {});

export default createTheme(theme);
